import script from "./PlayerStartGame.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayerStartGame.vue?vue&type=script&setup=true&lang=js"

import "./PlayerStartGame.vue?vue&type=style&index=0&id=e5079156&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5079156"]])

export default __exports__